
// stores 
import * as ProtocolsStore from '../../../redux/middleware/MedicalProtocolMiddleware';
import * as ProtocolConsumptionStore from '../../../redux/middleware/ProtocolConsumptionMiddleware';
import * as ProtocolConsumptionVisitStore from '../../../redux/middleware/ProtocolConsumptionVisit.Middleware';
import * as ContractsStore from '../../../redux/middleware/ContractMiddleware';
import * as PractitionersStore from "../../../redux/middleware/PractitionerMiddleware";
import * as ProvidersStore from "../../../redux/middleware/ProviderMiddleware";



// state
import { AppState } from '../../../redux/reducers';
import { ProtocolConsumption } from '../../../models/Entities/Protocols/ProtocolConsumption';
import { Protocol } from '../../../models/Entities/Protocols/Protocol';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { Practitioner } from "../../../models/Entities/Practitioners/Practitioner";
import { Provider } from '../../../models/Entities/Provider/Provider';
import { ProtocolConsumptionVisit } from '../../../models/Entities/Protocols/ProtocolConsumptionVisit';
import { IConsumptionsFilters } from '../../../models/Filters/ConsumptionsFilters';

//#region Props

interface IProps {
    ProtocolId: number | undefined;
    StageId: number | undefined;
    PatientNumberInProtocol: string | undefined;
    ProducerId: string | undefined;
    ProviderId: number | undefined;
    onChangeFilters: (filters: IConsumptionsFilters) => void;
}

interface ConnectedProps {
    isLoading: boolean;
    successLoading: boolean;
    error: string | null;

    haveConsumptionsToSettle: boolean;

    Consumptions: ProtocolConsumption[];
    protocol: Protocol | null;
    contract : Contract | null;
    Practitioners: Practitioner[];
    CurrentProvider: Provider | undefined;
 
    CurrentVisit: ProtocolConsumptionVisit | undefined;

    GetPersonByIdentifier: (identifier: string) => Practitioner | undefined;
    GetProtocolById: (protocolId: number) => Protocol | undefined;
}

interface MedicalServicesDispatchProps {
    GetMedicalProtocolById: typeof ProtocolsStore.actionCreators.GetMedicalProtocolById;
    GetAllMedicalProtocols: typeof ProtocolsStore.actionCreators.GetAllMedicalProtocols;
    GetAllProtocolConsumptionsByProtocol: typeof ProtocolConsumptionStore.ActionCreators.GetAllProtocolConsumptionsByProtocol;
    GetProtocolConsumptionToSettle: typeof ProtocolConsumptionStore.ActionCreators.GetProtocolConsumptionToSettle;
    DeleteProtocolConsumption: typeof ProtocolConsumptionStore.ActionCreators.DeleteProtocolConsumption;
    GetProviderConsumptions: typeof ProvidersStore.actionCreators.GetProviderConsumptions;
    GetAllProtocolContractAssociations: typeof ProtocolsStore.actionCreators.GetAllProtocolContractAssociations;
    GetContractById: typeof ContractsStore.actionCreators.GetContractById;
    GetAllPractitioners: typeof PractitionersStore.actionCreators.GetAllPractitioners;
    GetProviderById: typeof ProvidersStore.actionCreators.GetProviderById;
    GetProtocolVisitById: typeof ProtocolConsumptionVisitStore.actionCreators.GetProtocolVisitById;
    GetProtocolVisitByStageId: typeof ProtocolConsumptionVisitStore.actionCreators.GetProtocolVisitByStageId;
    GetAllConsumptionsByVisitId: typeof ProtocolConsumptionVisitStore.actionCreators.GetAllConsumptionsByVisitId;
}

export type Props = IProps & ConnectedProps & MedicalServicesDispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    
    const practitioners = state.Practitioners?.list || [];

    const AuxProtocol: Protocol | null =  state.MedicalProtocols?.list?.find((protocol: Protocol) => protocol.id === ownProps.ProtocolId) ?? null;

    const AuxProvider: Provider | undefined = state.Provider?.list?.find((provider: Provider) => provider.id === ownProps.ProviderId) ?? undefined;

    // get first contract associated from protocol
    const AuxContractId = AuxProtocol?.contractAssociation?.contractId || null;

    const AuxContract: Contract | null = state.Contract?.list?.find((contract: Contract) => contract.id === AuxContractId) ?? null;

    const AuxPractitioners = state.Practitioners?.list || [];

    let AuxConsumptions: ProtocolConsumption[] = ownProps.ProviderId ? AuxProvider?.consumptions ?? [] : AuxProtocol?.consumptions ?? [];

    const AuxConsumptionVisit : ProtocolConsumptionVisit | undefined = AuxProtocol?.ConsumptionVisits?.find((visit: ProtocolConsumptionVisit) =>
        visit.contractStageId === ownProps.StageId && visit.patientNumberInProtocol === ownProps.PatientNumberInProtocol ) ?? undefined;

    if(ownProps.StageId !== undefined && ownProps.PatientNumberInProtocol !== undefined) {
        AuxConsumptions = AuxConsumptionVisit?.consumptions ?? [];
    }

    return {
        isLoading: AuxProtocol?.isGettingConsumptions || false,
        successLoading: state.MedicalProtocols?.LoadingAllConsumptionsSuccess || undefined,
        error: state.MedicalProtocols?.ErrorGettingAllConsumptions || null,
        
        haveConsumptionsToSettle: AuxProtocol?.consumptionsToSettle?.some((consumption: ProtocolConsumption) => consumption.status === 6),
        
        Consumptions: AuxConsumptions ? AuxConsumptions.sort(
            (a: ProtocolConsumption, b: ProtocolConsumption) => new Date(b.serviceDueDate).getTime() - new Date(a.serviceDueDate).getTime()
        ) : [],
        protocol: AuxProtocol,
        contract: AuxContract,
        Practitioners: AuxPractitioners,
        CurrentProvider: AuxProvider,

        CurrentVisit: AuxConsumptionVisit,

        GetPersonByIdentifier: (identifier: string) => GetPersonByIdentifier(practitioners, identifier),
        GetProtocolById: (protocolId: number) => state.MedicalProtocols?.list?.find((protocol: Protocol) => protocol.id === protocolId) || null
    }
};

export const mapDispatchToProps = {
    ...ProtocolsStore.actionCreators,
    ...ProtocolConsumptionStore.ActionCreators,
    ...ContractsStore.actionCreators,
    ...PractitionersStore.actionCreators,
    ...ProvidersStore.actionCreators,
    ...ProtocolConsumptionVisitStore.actionCreators,
};


export const GetStatusDescription = (status: number): {description: string, class: string} => {

    /*
        NotSettled = 0,
        Pending = 1,
        Payee = 2,
        Settled = 3,
        Rejected = 4,
        Ignored = 5,
        ToSettle = 6,
        Invoiced = 7,
        PartialSettled = 8,

     */

    switch (status) {
        case 0:
            return {description: 'Pendiente de liquidación', class: 'status-not-settled'};
        case 1:
            return {description: 'Con saldo pendiente', class: 'status-pending'};
        case 2:
            return {description: 'Pagado', class: 'status-payee'};
        case 3:
            return {description: 'Liquidado', class: 'status-settled'};
        case 4:
            return {description: 'Rechazado', class: 'status-rejected'};
        case 5:
            return {description: 'Ignorado', class: 'status-ignored'};
        case 6:
            return {description: 'Por liquidar', class: 'status-to-settle'};
        case 7:
            return {description: 'Facturado', class: 'status-invoiced'};
        case 8:
            return {description: 'Parcialmente liquidado', class: 'status-partial-settled'};
        default:
            return {description: 'Unknown', class: 'status-unknown'};
    }
}

 // get person by identifier
const GetPersonByIdentifier = (persons: Practitioner[], identifier: string): Practitioner | undefined => {
  return persons.find((person: Practitioner) => person.userId === identifier);
}

export const GetRowClassByStatus = (status: number): string => {
    switch (status) {
        case 0:
            return ''; // 'status-not-settled-row';
        case 1:
            return ''; // 'status-pending-row';
        case 2:
            return 'status-payee-row';
        case 3:
            return 'status-settled-row';
        case 4:
            return ''; // 'status-rejected-row';
        case 5:
            return 'status-ignored-row';
        case 6:
            return 'status-to-settle-row';
        case 7:
            return 'status-invoiced-row';
        case 8:
            return 'status-partial-settled-row';
        default:
            return ''; // 'status-unknown-row';
    }
}

export const GetTypeOfServiceDescription = (typeOfService: number): string | undefined => {
    switch (typeOfService) {
        case 1:
            return undefined;
        case 2:
            return 'Adicional';
        case 3:
            return 'No Esperado';
        case 4:
            return 'No Realizado';
        default:
            return undefined;
    }
}
